import EdsPage from '#/pages/eds/EdsPage.vue'
import NotFoundPage from '#/pages/errors/NotFoundPage.vue'
import RouterPage from '@/routerPage.vue'
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: RouterPage,
      children: [
        { path: '', redirect: '/eds' },
        { path: '/eds', name: 'Eds', component: EdsPage },
        { path: '/404', name: '404', component: NotFoundPage },
        { path: '/:pathMatch(.*)*', name: '404', component: NotFoundPage }
      ]
    }
  ]
})

export default router
